import { DEBUG } from "../..";

export interface RefKeys {
  refName: string;
  count: number;
  refunds: number;
  features: number;
  revenue: number;
  share: number;
}

export interface RefKeyMonthly {
  year: number;
  month: number;
  refKeys: RefKeys[];
}

export type AppRefData = {
  [appName: string]: RefKeyMonthly[];
};

// api.ts
export async function LoadRefKeyDataAsync(): Promise<AppRefData> {
  return fetch('/dyn/get-ref.php', {
    method: 'GET',
    credentials: 'include'
  })
    .then((response) => response.json())
    .catch((error) => {
      if (DEBUG) console.error('Error:', error);
      return {};
    });
}
